import { Icon, IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import MetricsCard from "../../components/MetricsCard";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import {
  getCurrency,
  getDateTime,
  requestIdGenerator,
} from "../../helpers/Functions";
import OtpInput from "react-otp-input";
import Input from "../../components/Input";
import { Reducers } from "../../Interfaces/Interfaces";
import {
  getAggregatorTransactions,
  getCoordinatorTransactions,
  getTransactionSummary,
  reconfirmTransactions,
  transactionTypes,
} from "../../redux/actions/TransactionActions";
import {
  getCashoutAccount,
  getAggregatorDashboard,
  withdrawToBank,
  withdrawToWallet,
  sendOtpToUser,
} from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";
import AlertModal from "../../components/Modal";
import StatusAlert from "../../components/StatusAlert";
import WithdrawCommissionsAlertPopup from "../../components/WithdrawCommissionsAlertPopup";
import {
  getCoordinatorCashoutAccount,
  getCoordinatorTransactionDashboard,
  withdrawToBankCoordinator,
  withdrawWalletCoordinator,
} from "../../redux/actions/CoordinatorActions";
import DownloadTransactionForm from "../../components/downloadTransactionForm";
import "./mytransaction.scss";

export default function MyTransactions() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user: any = useSelector((state: Reducers) => state.user);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const transDashboard = useSelector(
    (state: Reducers) => state.transactionDashboard
  );
  const transactions = useSelector((state: Reducers) => state.transactions);
  const types = useSelector((state: Reducers) => state.transactionTypes);
  const userType = useSelector((state: Reducers) => state.userType);
  const cashout = useSelector((state: Reducers) => state.cashout);

  const [validatedEntityId, setValidatedEntityId] = React.useState("");

  const [account, setAccount] = React.useState("bank");
  const [handleWithDrawModal, sethandleWithDrawModal] = React.useState(false);
  const [walletAccount, setWalletAccount] = React.useState(
    cashout && cashout.agentPhoneNumber ? cashout.agentPhoneNumber : ""
  );
  const [cashoutAccount, setCashoutAccount] = React.useState(
    cashout && cashout.accountNumber
      ? cashout.agentPhoneNumber + `(${cashout.bankName})`
      : ""
  );
  const [amount, setAmount] = React.useState("");
  const [accountName, setAccountName] = React.useState(
    cashout && cashout.accountName ? cashout.accountName : ""
  );
  const [agentName, setAgentName] = React.useState(
    cashout && cashout.agentName ? cashout.agentName : ""
  );
  const [loading, setLoading] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [pin, setPin] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [subtitle, setSubtitle] = React.useState("");
  const [hasCashout, setCashout] = React.useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [searchState, setSearchState] = React.useState("");
  const [pageRoute, setpageRoute] = React.useState("");
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 0);

  const [state, setState] = React.useState([
    {
      startDate: today,
      endDate: today,
      key: "selection",
    },
  ]);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [typeState, setTypeStateChange] = React.useState(0);

  const [transactionStatus, setTransactionStatus] = React.useState(0);
  const [NewCashout, setNewCashout] = React.useState(false);
  let list = transactions && transactions.items;

  const [canDownloadReports, setCanDownloadReports] = React.useState(false);

  const [authenticate, setAuthenticate] = React.useState(false);
  const otp = useSelector((state: Reducers) => state.otp);
  const [authenticationOtp, setAuthenticationOtp] = React.useState("");
  const [submittedOtp, setSubmittedOtp] = React.useState(false);
  const [isTransaction, setIsTransaction] = React.useState(false);
  const [isBank, setIsBank] = React.useState(false);
  const [counter, setCounter] = React.useState(60);

  // var userPerm:any = user.permission||{};

  // if(userPerm!==null){
  //   setCanDownloadReports(userPerm.canDownloadReports);
  // }else{
  //   if(user.isAggregator) {
  //     setCanDownloadReports(true)
  //   }
  // }
  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleReconfirm = (ref: any) => {
    setAnchorEl(null);

    dispatch(reconfirmTransactions(ref));

    dispatch({
      type: "LOADING",
      payload: true,
    });
  };

  const callTransaction = () => {
    if (userType === "5") {
      dispatch(getAggregatorTransactions(paginationConfig));
      dispatch(getCashoutAccount(user.id));
      dispatch(getTransactionSummary(user.id));
      dispatch(getAggregatorDashboard());
      dispatch(transactionTypes());
    } else {
      dispatch(getCoordinatorTransactions(paginationConfig));
      dispatch(getCoordinatorCashoutAccount(user.id));
      getCoordinatorTransactionDashboard(JSON.stringify(filter));
      // get coordinator transaction summary
    }
  };

  React.useEffect(() => {
    if (otp && Object.entries(otp).length !== 0) {
      if (otp.exists) {
        setAuthenticate(true);
        setValidatedEntityId(otp.validatedEntityId);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  React.useEffect(() => {
    if (cashout && Object.entries(cashout).length !== 0) {
      setCashout(true);
      // setWalletAccount(cashout.agentPhoneNumber);
      setCashoutAccount(cashout.accountNumber + ` (${cashout.bankName})`);
      // setAgentName(cashout.agentName);
      setAccountName(cashout.accountName);

      setWalletAccount(
        cashout.agentPhoneNumber !== null
          ? cashout.agentPhoneNumber
          : cashout.phoneNumber
      );
      setAgentName(
        cashout.agentName !== null ? cashout.agentName : cashout.aggregatorName
      );
      if (cashout.hasCashoutAccount) {
        setNewCashout(true);
      } else {
        setNewCashout(false);
      }
    } else {
      setNewCashout(false);
      setCashout(false);
    }
  }, [cashout]);

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setAmount("");
    setTypeStateChange(0);
    setTransactionStatus(0);
    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    callTransaction();
  };
  const handleWithdrawal = () => {
    sethandleWithDrawModal(false);
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };
  const closeModal = () => {
    setLoading(false);
    setSubmitted(false);
    setPin("");
    setAmount("");
    dispatch({ type: "ALERT_MODAL", payload: false });
  };

  React.useEffect(() => {
    if (typeState !== 0) {
      filter.transactionType = typeState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
    }
    if (transactionStatus !== 0) {
      console.log({ transactionStatus });
      filter.status = transactionStatus;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
    }
    if (amount !== "") {
      filter.amount = amount;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
    }
    callTransaction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeState, transactionStatus, amount]);

  const handleSelect = (date: any) => {
    setState([date.selection]);

    filter.dateCreatedFrom = date.selection.startDate;
    filter.dateCreatedTo = date.selection.endDate;
    paginationConfig.whereCondition = JSON.stringify(filter);

    // dispatch({ type: "LOADING", payload: true });
    callTransaction();
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    callTransaction();
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    callTransaction();
    setNewCashout(false);
    setAuthenticate(false);
    setAuthenticationOtp("");
    setIsTransaction(false);
    setIsBank(false);
    setSubmitted(false);
    dispatch(getTransactionSummary(user.id));
  };
  const handleBank = (e: any) => {
    e.preventDefault();

    setLoading(true);
    setSubmitted(true);
    setCounter(60);
    setIsBank(true);
    setIsTransaction(true);

    const data = {
      phoneNumber: user.phoneNumber,
      channel: "1",
    };
    dispatch(sendOtpToUser(data));

    // setLoading(true);
    // setSubmitted(true);

    // const data = {
    //   accountName: accountName,
    //   accountNumber: cashout.accountNumber,
    //   bankCode: cashout.bankCode,
    //   bankName: cashout.bankName,
    //   amountToSend: amount,
    //   phoneNumber: cashout.phoneNumber,
    //   sendersPhoneNumber: user.phoneNumber,
    //   otp: pin,
    //   clientRequestId: requestIdGenerator(),
    // };
    // if (userType === "5") {
    //   dispatch(withdrawToBank(data));
    // } else {
    //   dispatch(withdrawToBankCoordinator(data));
    // }
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();

    setLoading(true);
    setSubmitted(true);
    setIsTransaction(true);

    const data = {
      phoneNumber: user.phoneNumber,
      channel: "1",
    };
    dispatch(sendOtpToUser(data));

    // const data = {
    //   amount: amount,
    //   recipientAccount: walletAccount,
    //   otp: pin,
    //   clientRequestId: requestIdGenerator(),
    // };
    // if (userType === "5") {
    //   dispatch(withdrawToWallet(data));
    // } else {
    //   const dataForCordinatorWallet = {
    //     amount: amount,
    //     recipientAccount: walletAccount,
    //     pin: pin,
    //     clientRequestId: requestIdGenerator(),
    //   };

    //   dispatch(withdrawWalletCoordinator(dataForCordinatorWallet));
    // }
  };

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    callTransaction();

    return () => {
      dispatch({
        type: "TRANSACTIONS",
        payload: {},
      });
      // dispatch({
      //   type: "DASHBOARD",
      //   payload: {}
      // });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
        setSubmitted(false);
        setLoading(false);
        setAuthenticate(false);
        setAuthenticationOtp("");
        setSubmittedOtp(false);
        setIsTransaction(false);
        setIsBank(false);
        setPin("");
      } else {
        enqueueSnackbar(alert.message, { variant: "success" });
        setSubmitted(false);

        handleRefresh();

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  const handleDownloadModal = () => {
    sethandleWithDrawModal(true);
    setpageRoute("mytransaction");
    dispatch({
      type: "ALERT_MODAL",
      payload: true,
    });
  };

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          // height: '100vh',
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
          }}
        >
          <div className="row mb-5 mytransaction-title justify-content-between col-12 align-items-center">
            <div className="px-0 col-6 mb-3 mb-md-0">
              <div className="px-0 col-md-9 col-md-6 col-12">
                <h6
                  style={{
                    fontFamily: PrimaryTheme.fonts?.LightFont,
                  }}
                >
                  ID: BNK-{user.id && user.id}
                </h6>
                <h4
                  style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                  }}
                >
                  {user.firstName && user.firstName}{" "}
                  {user.lastName && user.lastName}
                </h4>
                <h6
                  style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                  }}
                >
                  {user.state}
                </h6>
              </div>
              <div className="px-0 col-md-6 col-12 col-md-3">
                <h6
                  style={{
                    fontFamily: PrimaryTheme.fonts?.LightFont,
                    marginBottom: 0,
                  }}
                >
                  CURRENT BALANCE
                </h6>
                {userType === "5" && (
                  <h1
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.primary,
                      fontSize: PrimaryTheme.fontSizes?.heading,
                      marginBottom: 0,
                    }}
                  >
                    ₦
                    {dashboard.aggregatorCommissionBalance
                      ? dashboard.aggregatorCommissionBalance
                      : "0"}
                  </h1>
                )}

                {userType === "8" && (
                  <h1
                    style={{
                      fontFamily: PrimaryTheme.fonts?.MediumFont,
                      color: PrimaryTheme.primary,
                      fontSize: PrimaryTheme.fontSizes?.heading,
                      marginBottom: 0,
                    }}
                  >
                    ₦{transDashboard.volume ? transDashboard.volume : "0"}
                  </h1>
                )}
              </div>
            </div>
            <div
              style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                fontSize: 14,
                padding: "12px 24px",
                backgroundColor: "#296CF0",
                color: "#FFF",
                lineHeight: "21px",
                borderRadius: "4px",
                width: "fit-content",
                cursor: "pointer",
              }}
              onClick={handleWithdrawal}
            >
              Wallet withdrawal
            </div>
          </div>

          {/* cards  */}

          <div className="row mb-5">
            <div
              className="col-md-6 col-lg-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="second"
                value={dashboard ? getCurrency(dashboard.totalCommission) : "-"}
                background={PrimaryTheme.warn}
                title="Wallet Balance"
              />
            </div>

            <div
              className="col-md-6 col-lg-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="first"
                title="TOTAL TRANSACTIONS"
                value={
                  dashboard
                    ? transDashboard?.totalTransactions
                      ? String(transDashboard?.totalTransactions)
                      : "0"
                    : "0"
                }
                isValue
                // buttonTitle="Recommend POS"
                // buttonColor={PrimaryTheme.success}
              />
            </div>

            {/* <div
              className="col-md-4"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <div
                className="border-radius box-shadow p-3 overflow-hidden text-center"
                style={{
                  minHeight: 120,
                  backgroundColor: PrimaryTheme.white,
                }}
              >
                <h6
                  className="text-center mb-2"
                  style={{
                    fontFamily: PrimaryTheme.fonts?.MediumFont,
                    // fontSize: PrimaryTheme.fontSizes?.subtitle,
                    color: PrimaryTheme.dark,
                    textTransform: "uppercase",
                  }}
                >
                  {"Withdraw Commissions"}
                </h6>
                <button
                  className="btn btn-lg badge-pill btn-primary w-75"
                  onClick={handleWithdrawal}
                >
                  Withdraw
                </button>
              </div>
            </div> */}
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              {/* onDownload={() => dispatch({
                  type: 'ALERT_MODAL',
                  payload: true
                })} */}

              <Filters
                name="Download Transactions"
                onDownload={handleDownloadModal}
                hasDownloads
                hasSearch
                onClear={handleClear}
                searchState={searchState}
                isTransaction
                typeItems={types}
                typeState={typeState}
                handleSearch={(e: any) => setSearchState(e.target.value)}
                onTypeChange={(e: any) => setTypeStateChange(e.target.value)}
                handleSelect={(item: any) => handleSelect(item)}
                ranges={state}
                amount={amount}
                amountChange={(e: any) => setAmount(e.target.value)}
                transactionStatus={transactionStatus}
                transactionStatusChange={(e: any) =>
                  setTransactionStatus(e.target.value)
                }
              />
            </div>
          </div>

          <div className="row " style={{ paddingBottom: "150px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive py-3 px-0" id="DataTable">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th scope="col">S/N</th>
                          <th scope="col">Type</th>
                          <th scope="col">Date</th>
                          <th scope="col">Sender</th>
                          <th scope="col">Receiver</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Status</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr key={index} className="text-center">
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td>
                                <div className="row m-0 justify-content-start align-items-center">
                                  {(item.transactionType === 1 ||
                                    item.transactionType === 3) && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionType === 4 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionType === 5 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionType === 2 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.info,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}

                                  {item.transactionType === 22 && (
                                    <Icon
                                      fontSize="small"
                                      style={{
                                        color: PrimaryTheme.lightGreen,
                                        marginRight: 5,
                                      }}
                                    >
                                      fiber_manual_record
                                    </Icon>
                                  )}
                                  {item.transactionTypeName}
                                </div>
                              </td>
                              <td>{getDateTime(item.transactionDate)}</td>
                              <td>{item.sender}</td>
                              <td>{item.receiver}</td>
                              <td>{getCurrency(item.amount)}</td>
                              {/* <td>{item.aggregatorCommission ? getCurrency(item.aggregatorCommission) : "-"}</td> */}
                              <td style={{ display: "flex" }}>
                                {item.status === 1 && (
                                  <span className="badge badge-pill badge-warning p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}
                                {item.status === 2 && (
                                  <span className="badge badge-pill badge-danger p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}
                                {item.status === 3 && (
                                  <span className="badge badge-pill badge-success p-2 pl-3 pr-3 mr-1">
                                    {item.statusName}
                                  </span>
                                )}
                              </td>
                              <td>
                                <Tooltip
                                  title="View"
                                  style={{ cursor: "pointer" }}
                                >
                                  <Icon
                                    fontSize="small"
                                    className="mr-2"
                                    onClick={() =>
                                      history.push(
                                        `/myWallet/details/${item.id}`
                                      )
                                    }
                                  >
                                    visibility
                                  </Icon>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {transactions.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={transactions.total && transactions.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
      {handleWithDrawModal ? (
        <AlertModal showClose maxWidth="md">
          <DownloadTransactionForm routePage={pageRoute} />
        </AlertModal>
      ) : (
        <div>
          <WithdrawCommissionsAlertPopup
            PrimaryTheme={PrimaryTheme}
            cashout={cashout}
            cashoutAccount={cashoutAccount}
            account={account}
            setAccount={setAccount}
            setAccountName={setAccountName}
            walletAccount={walletAccount}
            setWalletAccount={setWalletAccount}
            agentName={agentName}
            setAgentName={setAgentName}
            accountName={accountName}
            submitted={submitted}
            pin={pin}
            setPin={setPin}
            handleSubmit={handleSubmit}
            loading={loading}
            handleBank={handleBank}
            hasCashout={hasCashout}
            history={history}
            setAmount={setAmount}
            NewCashout={NewCashout}
            authenticate={authenticate}
            validatedEntityId={validatedEntityId}
            setAuthenticate={setAuthenticate}
            title={title}
            subtitle={subtitle}
            handleRefresh={handleRefresh}
            setAuthenticationOtp={setAuthenticationOtp}
            authenticationOtp={authenticationOtp}
            setSubmittedOtp={setSubmittedOtp}
            submittedOtp={submittedOtp}
            counter={counter}
            setCounter={setCounter}
            isTransaction={isTransaction}
            isBank={isBank}
          />
          <StatusAlert
            title={title}
            subtitle={subtitle}
            buttonTitle={"Close"}
            onClick={handleRefresh}
          ></StatusAlert>
        </div>
      )}
    </React.Fragment>
  );
}
